"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialContentBlocks = exports.defaultTemplate = void 0;
exports.defaultTemplate = function (contentType) {
    return "<div class=\"eg-content-editor\" data-type=\"" + contentType + "\"></div>";
};
exports.getInitialContentBlocks = function (itemsCount, getDefaultChildContentBlock) { return Array.from({ length: itemsCount }, function (_, index) { return getDefaultChildContentBlock(index); }); };
